import React from 'react';
import { Link } from 'react-router-dom';
import me from '../assets/me.jpg';
import {MdDashboard} from 'react-icons/md';
import {motion} from 'framer-motion';
const Profile = () => {
  const optionsY = {
    initial: {
      y: "-100%",
      opacity: 0,
    },
    animate: {
      y: 0,
      opacity: 1,
    },
  };
  const optionsX = {
    initial:{
      x:"-100vw",
      opacity:0
    },
    animate:{
        x:0,
        opacity:1
    }
  }
  return <section className='profile'>
    <main className='profileMain'>
        <motion.img {...optionsY}  src={me} alt="Profile" />
        <motion.h5 {...optionsY} transition={{delay:0.3}}>Muhammad Hasnine</motion.h5>
        <motion.div {...optionsY} transition={{delay:0.5}} className='dashboard'>
            <MdDashboard/>
            <Link to='/admin/dashboard'>Dashboard</Link>
        </motion.div>
        <motion.div {...optionsX}>
            <Link to='/myorders'>Orders</Link>
           
        </motion.div>
        <motion.button {...optionsX} transition={{delay:0.3}}>Log out</motion.button>
    </main>
  </section>
}

export default Profile